import { Link } from "react-router-dom";
import { LOGO_URL } from "../data/site";

// Official Digsby Early Learning logo lockup (butterfly + wordmark).
export const Logo = ({ height = 52, className = "", linkClassName = "" }) => (
  <Link
    to="/"
    data-testid="brand-logo-link"
    className={`inline-flex items-center group ${linkClassName}`}
    aria-label="Digsby Early Learning home"
  >
    <img
      src={LOGO_URL}
      alt="Digsby Early Learning logo, colorful butterfly with the DIGSBY wordmark"
      style={{ height }}
      className={`w-auto object-contain transition-transform duration-300 group-hover:scale-105 ${className}`}
    />
  </Link>
);

export default Logo;
